/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Country } from '@app/settings/countries/countries.model';
import { ApiQuery } from '@app/core/http/api-query';
import { CountriesService } from '@app/settings/countries/countries.service';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { CountriesFormService } from '@app/settings/countries/countries-form.service';
import { Logger } from '@app/core';

const log = new Logger('CountriesSelectComponent');

@Component({
  selector: 'app-countries-select',
  templateUrl: './countries-select.component.html',
  styleUrls: ['./countries-select.component.scss'],
})
export class CountriesSelectComponent implements OnInit {
  data: Array<Country>;
  apiQuery: ApiQuery = new ApiQuery();
  loader: boolean;
  @Input() hideLabel = false;
  @Input() onlyActive = true;
  @Input() parentFormGroup: FormGroup;
  @Output() select = new EventEmitter();
  input$ = new Subject<string>();

  constructor(private countryService: CountriesService, private countryFormService: CountriesFormService) {}

  ngOnInit() {
    this.loadCountries();
    // const preSelectedCountry = this.parentFormGroup.get('country');
    // const preSelectedCountryId = this.parentFormGroup.get('country_id');
    /**
     * Попълва избраното country на едит.
     * Ако има FormControl 'country' в parentFormGroup.
     * Ако няма ще се опита да го get-не по ID
     */
    //   if (preSelectedCountry) {
    //     /*
    //      * Следи за промени в country FormControl-a и когато намери валиден Country спира да следи
    //      */
    //     const preselectedCountrySubscriber = preSelectedCountry.valueChanges.subscribe((country: any) => {
    //       if (country && country.name) {
    //         this.data = of([country]);
    //         preselectedCountrySubscriber.unsubscribe();
    //       }
    //     });
    //   } else if (preSelectedCountryId) {
    //     /*
    //      * Ако не е намерено country FormControl-a търси country_id FormControl и се опитва да get-не country-то по ID
    //      */
    //     const preselectedCountryIdSubscriber = preSelectedCountryId.valueChanges.subscribe((countryId: any) => {
    //       if (countryId) {
    //         this.loadCountryById(countryId);
    //         preselectedCountryIdSubscriber.unsubscribe();
    //       }
    //     });
    //   }
    //   this.countriesSearch();
  }

  // loadCountries(keyword?: string) {
  //   this.loader = true;
  //
  //   this.countryService.index(this.apiQuery.addFilter('name', keyword)).subscribe((response: PaginatedResponse) => {
  //     this.data = of(response.data);
  //     this.loader = false;
  //   });
  // }

  // loadCountryById(id: number) {
  //   this.loader = true;
  //   this.countryService.show(id).subscribe((country: Country) => {
  //     this.data = [country];
  //     this.loader = false;
  //   });
  // }

  loadCountries(keyword?: string) {
    this.loader = true;

    if (this.onlyActive) {
      this.apiQuery.addFilters({ active: true });
    }

    this.countryService.index(this.apiQuery.setLimit(9999)).subscribe((response: PaginatedResponse) => {
      this.data = response.data;
      this.loader = false;
    });
  }

  // countriesSearch() {
  //   this.input$
  //     .pipe(
  //       tap(() => (this.loader = true)),
  //       debounceTime(1000),
  //       distinctUntilChanged(),
  //       switchMap(term =>
  //         this.countryService.index(this.apiQuery.addFilter('name', term)).pipe(
  //           catchError(() => of([])), // empty list on error
  //           tap(() => (this.loader = false))
  //         )
  //       )
  //     )
  //     .subscribe((countries: PaginatedResponse) => {
  //       this.data = countries.data;
  //       this.loader = false;
  //     });
  // }

  onChange(country: any) {
    this.select.emit(country);

    if (this.parentFormGroup.get('country')) {
      this.parentFormGroup.get('country').patchValue(country);
    }
  }

  add(searchTerm: string) {
    this.countryFormService.open(new Country().deserialize({ name: searchTerm })).then(
      (response) => {
        this.loadCountries();
        this.parentFormGroup.get('country_id').setValue(response.id);
      },
      (err) => {
        log.error(err);
      }
    );
  }

  edit() {
    if (this.parentFormGroup.get('country_id').value) {
      this.countryFormService
        .open(new Country().deserialize({ id: this.parentFormGroup.get('country_id').value }))
        .then(
          (response) => {
            //  this.loadCountries(response.id);
            this.parentFormGroup.get('country_id').setValue(response.id);
            if (this.parentFormGroup.get('country')) {
              this.parentFormGroup.get('country').patchValue(response);
            }
          },
          (err) => {
            log.error(err);
          }
        );
    }
  }
}
